import Box from '@/common/components/Box'
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import ListHeader from '@/common/components/ListHeader'
import { DatePickerWithRange } from '@/common/components/ui/dateRangePicker'
import { useFilterDate } from '@/common/hooks/useFilterDate'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { ChartDataTransformer } from '@/common/services/chartDataTransformer'
import { Mapper } from '@/common/services/mapper'
import { ChartData } from '@/common/types/chart.type'
import { useDashboardData } from '@/features/dashboard/hooks/useDashboardData'
import { ChartSection } from '@/features/dashboard/pages/components/ChartSection'
import { PieChartIcon, X } from 'lucide-react'
import { startOfMonth } from 'date-fns'
import { useMemo, useState } from 'react'
import { Button } from '@/common/components/ui/button'

const Show = () => {
  const { filterParams, setFilterParams } = useFilterParams()

  const [isAllTime, setIsAllTime] = useState(false)

  const defaultDate = useMemo(() => {
    const today = new Date()
    return {
      from: startOfMonth(today),
      to: today
    }
  }, [])

  const effectiveDate = isAllTime 
    ? undefined
    : (filterParams?.date?.from ? filterParams.date : defaultDate)

  const effectiveFilterParams = {
    ...filterParams,
    date: effectiveDate
  }

  const { date, formattedDate } = useFilterDate(effectiveFilterParams)

  const {
    data: dashboardData,
    isLoading,
    error: companyBillsError = {} as any,
    refetch: refetchDashboard,
  } = useDashboardData<ChartData[]>({
    filters: {
      startDate: formattedDate.from,
      endDate: formattedDate.to,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: ChartDataTransformer.chartTransformer(),
    }),
  })

  return (
    <div className="flex flex-col gap-6 max-h-[calc(100vh-64px)] overflow-y-auto">
      <ListHeader Icon={<PieChartIcon className="size-10" strokeWidth={1} />} title="Dashboard" />

      <ErrorMessageWrapper
        className="h-[calc(100vh-192px)]"
        statusCode={companyBillsError?.status}
        refetchFunction={refetchDashboard}
      >
        <div className="flex flex-col gap-6">
          <div className="flex gap-1">
            <DatePickerWithRange 
              date={date} 
              setDate={(date) => {
                setIsAllTime(false)
                setFilterParams((params) => ({ ...params, date }))
              }} 
            />
            {(date?.from && !isAllTime) && (
              <Button 
                variant={"badge"}
                size={"badge"}
                className='bg-white-100 rounded-xl w-8 max-w-8 p-0'
                onClick={() => {
                  setIsAllTime(true)
                  setFilterParams((params) => ({ ...params, date: undefined }))
                }}
              >
                <X className='max-w-4' />
              </Button>
            )}
          </div>

          {isLoading ? (
            <Box>Carregando...</Box>
          ) : (
            <div className="grid grid-cols-12 gap-6">
              {dashboardData?.map((chartData) => (
                <ChartSection key={chartData.title} chartData={chartData} />
              ))}
            </div>
          )}
        </div>
      </ErrorMessageWrapper>
    </div>
  )
}

export default Show
